/**
 * waAudit — Helper para registrar acciones en wa_audit_trail.
 */

import { supabase } from '@/lib/supabase';

export async function waAuditLog(
  tenantId: string,
  conversationId: string | null,
  actorId: string,
  action: string,
  details: Record<string, unknown> = {},
) {
  await supabase.from('wa_audit_trail').insert({
    tenant_id: tenantId,
    conversation_id: conversationId,
    actor_id: actorId,
    action,
    details,
  });
}
